import { Immutable } from "immer";
import React from "react";
import { formatNumber } from "tsi-common-react/src/utils/format";
import { CAPTION_MEDIUM_CLASS_NAME } from "tsi-common-react/src/utils/typography";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import styles from "./index.module.scss";

export interface IHistogramRow {
    score: number;
    count: number;
}

type IProps = Immutable<{
    row: IHistogramRow;
    totalCount: number;
}> & {
    onRatingClick: (
        rating: number,
        event: React.MouseEvent<HTMLElement>,
    ) => void;
};

export const HistogramRow = (props: IProps) => {
    // TODO(i18n): Use ngettext for proper plural handling: ngettext(msgid`${props.row.score} star`, `${props.row.score} stars`, props.row.score)
    const noun = props.row.score === 1 ? "star" : "stars";
    return (
        <a
            href="#review-menu"
            key={props.row.score}
            onClick={props.onRatingClick.bind(this, props.row.score)}
        >
            <div className={styles.tempurReviewsTotalRow}>
                <div
                    className={concatClassNames([
                        CAPTION_MEDIUM_CLASS_NAME,
                        styles.tempurReviewsTotalTitle,
                    ])}
                >
                    {/* TODO(i18n): Replace manual plural logic with ngettext to handle pluralization correctly for all languages */}
                    {props.row.score} {noun}
                    &nbsp;
                    <span className={styles.tempurReviewsTotalTitleCount}>
                        ({formatNumber(props.row.count)})
                    </span>
                </div>
                <div className={styles.tempurReviewsTotalBar}>
                    <progress
                        value={props.row.count}
                        max={props.totalCount}
                    ></progress>
                </div>
            </div>
        </a>
    );
};
